export default [{
  name: 'setting',
  path: 'setting',
  component: () => import('./Setting.vue'),
  meta: {
    title: '系统设置'
  }
}]



// WEBPACK FOOTER //
// ./src/router/setting/index.js